import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {SearchOrder} from './model/search-order.model';

@Component({
  selector: 'lps-search-order',
  templateUrl: './search-order.component.html',
  styleUrls: ['./search-order.component.scss']
})
export class SearchOrderComponent implements OnInit {

  @Input() order: SearchOrder;
  @Input() notMarginRight: boolean;
  @Output() orderChange = new EventEmitter<SearchOrder>();

  order$: BehaviorSubject<SearchOrder>;

  orderTypes: SearchOrder[] = [
    {
      label: 'Relevância',
      value: null,
      direction: null,
    },
    {
      label: 'Menor valor',
      value: 'PRICE',
      direction: 'ASC',
    },
    {
      label: 'Maior valor',
      value: 'PRICE',
      direction: 'DESC',
    },
    {
      label: 'Data de atualização',
      value: 'UPDATED_AT',
      direction: 'DESC',
    },
    {
      label: 'Área do imóvel',
      value: 'AREA',
      direction: 'DESC',
    }
  ];

  ngOnInit() {
    this.order$ = new BehaviorSubject<SearchOrder>(this.order || null);
  }

  changeOrder(order: SearchOrder) {
    this.order = order;
    this.order$.next(this.order);
    this.orderChange.emit(this.order);
  }

}
